import { render, staticRenderFns } from "./route-inquiry.vue?vue&type=template&id=412765cc&"
import script from "./route-inquiry.vue?vue&type=script&lang=js&"
export * from "./route-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports